import React from "react";

const Search = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.9762 18L10.5334 11.7C10.0221 12.1 9.43406 12.4167 8.76933 12.65C8.1046 12.8833 7.39726 13 6.64731 13C4.78947 13 3.21713 12.3708 1.93028 11.1125C0.643425 9.85417 0 8.31667 0 6.5C0 4.68333 0.643425 3.14583 1.93028 1.8875C3.21713 0.629167 4.78947 0 6.64731 0C8.50515 0 10.0775 0.629167 11.3643 1.8875C12.6512 3.14583 13.2946 4.68333 13.2946 6.5C13.2946 7.23333 13.1753 7.925 12.9367 8.575C12.6981 9.225 12.3742 9.8 11.9652 10.3L18.4079 16.6L16.9762 18ZM6.64731 11C7.92564 11 9.01222 10.5625 9.90705 9.6875C10.8019 8.8125 11.2493 7.75 11.2493 6.5C11.2493 5.25 10.8019 4.1875 9.90705 3.3125C9.01222 2.4375 7.92564 2 6.64731 2C5.36898 2 4.2824 2.4375 3.38757 3.3125C2.49274 4.1875 2.04533 5.25 2.04533 6.5C2.04533 7.75 2.49274 8.8125 3.38757 9.6875C4.2824 10.5625 5.36898 11 6.64731 11Z"
      fill={color}
    />
  </svg>
);

Search.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Search;
